import { Card, Space } from 'antd';
import {
  LoadingOutlined
} from '@ant-design/icons';
import BreadcrumbList from '../../../Shared/Components/Breadcrumb/Breadcrumb';
import './MedicaidMeetings.scss';

const MedicaidMeetings = () => {
    const columns = [
    {
      label: "Medicaid",
      link: "/home/medicaid",
    },
    {
      label: "Meeting Details",
      link: "",
    },
  ];
    return (
        <div className='medicaidMeetings'>
            <Card bodyStyle={{ padding: "10px" }}>
          <BreadcrumbList active={columns} />
        </Card>
        <Card>
           <Space><p>Development In Progress! <LoadingOutlined /></p></Space>
        </Card>
        </div>
    )
}

export default MedicaidMeetings;